import ContainerRoutes from "../quality_control/container";

export default [
    ...ContainerRoutes
]
